import React from 'react'

export default function Contact() {
    return (
        <>
        
        
            <div id='contac' className="contact">
                <div className="containe">
                <div className="aboutseclogo"><img src="/images/logo.png" alt="" />
                </div>      
                        <div className="row justify">
                            <div className="col-6">
                           
                               <p className='cos'> Lorem ipsum dolor sit amet consectetur adipisicing elit. Placeat non, quas atque quam praesentium eum explicabo distinctio laboriosam ea natus</p>
                                <div className="about-ar">
                                <ul className='header-ul mar '>
                                <li ><i class="fab fa-facebook-square"></i></li>
                                <li ><i class="fab fa-twitter-square"></i></li>
                                <li ><i class="fab fa-instagram"></i></li>
                                <li ><i class="fab fa-pinterest"></i></li>
                            </ul>
                            </div>
                            </div>
                        </div>
                       
                        
                        
                    </div>
                </div>
            
        </>
    )
}
